<template>
  <div id="join">
    <div class="join-content">
      <div class="join-banner">
        <img src="../../../static/images/join-banner.jpg" alt="">
      </div>

      <div class="join-main">

        <el-carousel :interval="10000000" arrow="always" trigger="click" indicator-position="outside" height="800px">
          <el-carousel-item v-for="item in car_item" :key="item.id" :label="item.title">

            <div class="carousel-item-con">
              <p class="atitlt">{{ item.title }}</p>
              <div class="carousel-item-decon clearfix">
                <div class="decon-left">
                  <div class="decon-left-cir"><div class="decon-left-cir2"></div></div>
                  <div class="decon-left-line"></div>
                </div>
                <div class="decon-right" v-html="item.content">
                </div>
              </div>
            </div>

          </el-carousel-item>
        </el-carousel>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavDom from '@/components/navtop/navloginbefore'
export default {
  name: 'join',
  data() {
    return {

      car_item: {}
      
    }
  },
  created () {
    this.getjoin();
  },
  methods: {
    getjoin() {
                var _this = this;
                _this.$http({
                    method: 'get',
                    url: _this.$api + '/service/agent/recruit/list'
                }).then((res) => {
                    console.log(res.data);
                    if(res.data.code == 200) {
                        _this.car_item = res.data.data;
                        console.log(res.data.data);
                    }
                })
            }
  },
  components: {
    NavDom
  }
}
</script>

<style lang="stylus" scoped>
  .join-banner
    img
      width 100%

  .join-main
    width 1080px
    margin 0 auto

    .el-carousel__item
     h3
      color #475669
      font-size 18px
      opacity 0.75
      line-height 300px
      margin 0
      background-color #99a9bf
  
  .carousel-item-con
    width 765px
    margin 0 auto

    .atitlt
      text-align center
      margin 40px 0
      color #123e97
      font-size 24px

    .carousel-item-decon

      .decon-left
        float left
        width 18px
        text-align center
        margin-right 122px

        .decon-left-cir
          width 16px
          height 16px
          border 1px solid #123e97
          border-radius 50%

          .decon-left-cir2
            width 12px
            height 12px
            margin 2px
            background-color #123e97
            border-radius 50%

        .decon-left-line
          width 6px
          height 450px
          background-color #123e97
          display inline-block
          margin-top 10px

      .decon-right
        float left
        width 625px
  
</style>
<style type="text/css">
  .join-main .el-carousel{
    overflow: inherit; 
  }
  .el-carousel ul{
    top: -70px;
    position: absolute;
    height: 50px;
  }
  .el-carousel__container{
    border-top: 1px solid #000000;
  }
  .join-main{
    padding: 100px 0 0 0;
  }
  .el-carousel__indicator .el-carousel__button span{
    font-size: 24px;
  }
  .el-carousel__indicators--outside button{
    background-color: transparent!important;
    opacity: 1!important;
    filter:Alpha(opacity=100)!important;
  }
  .is-active span{
    color: #123e97;
  }
  .el-carousel__container{
    overflow-x: hidden;
  }      
</style>


// WEBPACK FOOTER //
// src/components/join/join.vue